import React from 'react';
import { Outlet, createRoute, redirect } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { OrderLayout } from 'components/layout';
import { store } from 'store/store';
import { selectUserAuthenticated } from 'store/user';

export const authenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authenticated',
  beforeLoad: async () => {
    const state = store.getState();
    const isAuthenticated = selectUserAuthenticated(state);

    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <OrderLayout>
      <Outlet />
    </OrderLayout>
  );
}
